import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Label from '../label/label';
import styled, { css } from 'styled-components';
import formatDate from 'zengenti-forms-package/utils/format-date';

const DateRangeStyled = styled.div`
  ${({ useDefaultTheme }) => {
    return css`
      ${useDefaultTheme &&
        css`
          .daterange-wrapper {
            display: flex;
            flex-direction: column;
            input {
              &:first-child {
                margin: 0 0 8px 0;
              }
            }
          }
        `}
    `;
  }};
`;

const DateRange = ({
  className,
  id,
  label,
  validations,
  setDateRangeValues,
  formId,
  useDefaultTheme,
}) => {
  const isRequired = validations && validations.required ? true : false;
  const onlyPassedDates = validations && validations.pastDateTime;

  const d = new Date();
  const todaysDate = d.toISOString();

  const [toDate, setToDate] = useState('');
  const [fromDate, setFromDate] = useState('');

  const _handleDateChange = (dateType, formId, id, value) => {
    _updateDateProps(dateType, value);
    const d = new Date(value);
    const isoDate = d.toISOString();
    setDateRangeValues(formId, id, dateType, isoDate);
  };

  const _updateDateProps = (type, date) => {
    switch (type) {
      case 'from': {
        const d = new Date(date);
        const newDate = d.toISOString();
        setFromDate(newDate);
        break;
      }
      case 'to': {
        const d = new Date(date);
        const newDate = d.toISOString();
        setToDate(newDate);
        break;
      }
      default:
        return;
    }
  };
  return (
    <DateRangeStyled
      className={`daterange-container`}
      useDefaultTheme={useDefaultTheme}
    >
      <Label id={id} label={label} isRequired={isRequired} />
      <div className="daterange-wrapper">
        <Label
          id="date-from"
          label="Date from"
          isHidden
          className="label-daterange"
        />
        <input
          type="date"
          id="date-from"
          name={id}
          max={
            onlyPassedDates && !toDate
              ? formatDate(todaysDate, 'yyyy-MM-dd')
              : onlyPassedDates && toDate
              ? formatDate(toDate, 'yyyy-MM-dd')
              : toDate
              ? formatDate(toDate, 'yyyy-MM-dd')
              : ''
          }
          className={`${className ? className : ''} input-daterange`}
          onChange={e => _handleDateChange('from', formId, id, e.target.value)}
        />
        <Label
          id="date-to"
          label="Date to"
          isHidden
          className="label-daterange"
        />
        <input
          type="date"
          id="date-to"
          name={id}
          max={onlyPassedDates ? formatDate(todaysDate, 'yyyy-MM-dd') : ''}
          min={formatDate(fromDate, 'yyyy-MM-dd')}
          className={`${className ? className : ''} input-daterange`}
          onChange={e => _handleDateChange('to', formId, id, e.target.value)}
        />
      </div>
    </DateRangeStyled>
  );
};

DateRange.propTypes = {
  className: PropTypes.string,
  formId: PropTypes.string,
  setDateRangeValues: PropTypes.func,
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  validations: PropTypes.object,
  useDefaultTheme: PropTypes.bool,
};

export default DateRange;
